<template>
	<div class="add_backimg">
		<div class="content minheight clearfix">
			<div class="left_types">
				<div class="left_search">
					<div class="left_searchTitle">虚拟仿真</div>
					<div class="left_searchCont">
						<input type="text" v-model="name" @keyup.enter="currentChange(1)" placeholder="输入关键词后点击按钮搜索" />
						<div class="left_searchIcon" @click="currentChange(1)">
							<i class="el-icon-search"></i>
						</div>
					</div>
				</div>
				<div class="left_filter clearfix">
					<div class="left_filterItem text-ellipsis" :class="item.id == typeId?'active':''" v-for="item in typeList" @click="typeChange(item.id)">
						{{item.name}}<span v-if="false">（{{item.resourceDetailCount || 0}}）</span>
					</div>
				</div>
				<div class="left_foot">
					<span class="left_footText">VRTUAL SIMLATION</span>
				</div>
			</div>
			<div class="right_list">
				<div class="right_title">
					<img src="@/images/titletext.png" />
					<div class="right_titleText" v-if="typeId == majorIdForAll">
						虚拟仿真
					</div>
					<div class="right_titleText" v-if="typeId == item.id" v-for="item in typeList">
						{{item.name}}
					</div>
				</div>
				<div class="right_lablist clearfix" >
					<emptymain :emptytext="'暂无实验'" :emptylist='experiments'></emptymain>
					<div class="right_itemlab" v-for="(item,index) in experiments">
						<div class="right_coverLab">
							<div class="right_coverImg coverItem">
								<img :src="baseurl + item.cover" />
							</div>
							<div class="right_collect" @click.stop="simulationCollection(item)">
								<div class="right_collectNormal">
									<img src="@/images/collected.png" v-if="item.isCollection" />
									<img src="@/images/collecting.png" v-if="!item.isCollection" />
									<span>{{item.collectionCount || 0}}</span>
								</div>
								<div class="right_collectHover">
									<span v-if="item.isCollection">取消收藏</span>
									<span v-if="!item.isCollection">点击收藏</span>
								</div>
							</div>
							<div class="right_type">
								{{item.typeName || "虚拟仿真实验"}}
							</div>
						</div>
						<div class="lab_title text-ellipsistwo">【{{item.mode == '3'?'训练':'考核'}}】{{item.name}}</div>
						<div class="lab_click">{{item.clicks || 0}}人已浏览</div>
						<div class="right_labBtn">
							<div class="right_labBtnBox clearfix">
								<div class="right_labBtnMore clearfix">
									<div class="right_labClick l" @click="viewSimulation(item)" v-if="item.mode == '3'">
										<img src="@/images/index_inTest.png" />
										<span>进入<br />训练</span>
									</div>
									<div class="right_labClick r" @click="viewSimulation(item)" v-if="item.mode == '2' && item.vrExamineState == 1">
										<img src="@/images/index_inExam.png" />
										<span>进入<br />考核</span>
									</div>
								</div>
								<div class="right_labBtnIt" @click="getLabInfo(item)">实验详情 <i class="el-icon-arrow-right"></i></div>
							</div>
						</div>
					</div>
					<div class="all_current">
						<el-pagination prev-text='上一页' next-text='下一页' background @current-change="currentChange" :page-size="limit" :current-page="current" layout="prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { userCollectionSave, userCollectionRemove } from '@/api/simulation.js'
	import { majormainDO, listMajorByPid } from '@/api/major'
	import { vrDetailPage, vrPaperUserInit, saveResourceDetailRecord } from '@/api/simulation'
	import { getStorageToken } from '@/utils/auth'
	export default {
		data() {
			return {
				current: 1,
				limit: 20,
				total: 0,
				typeId: this.majorIdForAll,
				name: '',
				typeList: [],
				experiments: [],
			}
		},
		created() {
			this.typeId = this.$route.query.typeId ?this.$route.query.typeId :this.majorIdForAll;
			this.getMajormainDO()
			this.gettVrPaperDO()
		},
		mounted() {

		},
		methods: {
			nameChange(){
				if(!this.name){
					this.currentChange(1)
				}
			},
			typeChange(id) {
				if(this.typeId == id) {
					this.typeId = this.majorIdForAll
				} else {
					this.typeId = id;
				}
				this.current = 1;
				this.gettVrPaperDO();
			},
			currentChange(current) {
				this.current = current;
				this.gettVrPaperDO()
			},
			getLabInfo(item) {
				this.$router.push({
					name: 'fictitiousinfo',
					query: {
						vrDetailId: item.id,
						resourceId: item.resourceId,
					}
				})
			},
			viewSimulation(item) {
				var vrDetailId = item.id;
				var resourceId = item.resourceId;
				var token = getStorageToken();
				if(token) {
					saveResourceDetailRecord({
						vrDetailId: vrDetailId,
						resourceId: resourceId,
					}).then(res => {
						if(item.version == '2.2.0') {
							window.open('#/fictitiousdetail?type=data&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						} else if(item.mode && item.mode == '2') {
							if(item.version == '2.0.0') {
								window.open('#/fictitiousdetail?type=exam&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
							} else {
								vrPaperUserInit({
									vrDetailId: vrDetailId,
									resourceId: resourceId,
									expertype: item.typeId,
								}).then(res => { //判断是否有关联的试卷，存在则直接返回，不存在则创建后返回
									if(res.code == 'OK') {
										window.open('#/fictitiousdetail?type=index&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId + '&pid=' + res.data)
									}
								})
							}
						} else {
							window.open('#/fictitiousdetail?type=test&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			getMajormainDO() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(({
					data
				}) => {
					this.typeList = data;
				})
			},
			gettVrPaperDO() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.typeId == this.majorIdForAll ? null : this.typeId,
					name: this.name ? this.name : null,
					current: this.current,
					limit: this.limit,
				}
				vrDetailPage(data).then(res => {
					this.experiments = res.data.records;
					this.total = res.data.total;
				})
			},
			//仿真收藏
			simulationCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						userCollectionSave({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.gettVrPaperDO();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						userCollectionRemove({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.gettVrPaperDO();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
		},
	}
</script>

